import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class CommonHeaderService {
  private headers: { [key: string]: string } = {}

  /**
   * Creates an instance of CommonHeaderService.
   */
  constructor() {}

  /**
   * Sets a header value for the specified key.
   * @param key The header key.
   * @param value The header value.
   */
  public set(key: string, value: string) {
    this.headers[key] = value
  }

  /**
   * Removes the header for the specified key.
   * @param key The header key to remove.
   */
  public remove(key: string) {
    delete this.headers[key]
  }

  /**
   * Returns a copy of all headers.
   */
  public getAll() {
    return { ...this.headers }
  }
}
